import { ITEM_KEY_CATEGORY_SEPARATOR } from '../../constants';
import _ from 'lodash';
import { sendGoogleAnalytics } from '../../api';
import { analyticsEvents } from '../../utils/firebaseAnalytics';
import { deletePendingOrderBasketItem } from '../../api/pendingOrder';
import { isStringNotNull } from "../../utils";
import store from "../../redux/store";
import { showMessageModal } from "../../redux/actions";

export const findOptionParent = (option: any, items: any) => {
  const { categoryKey: optionKey } = option;
  const lastOptionKey = _.last(optionKey.split(ITEM_KEY_CATEGORY_SEPARATOR));

  let foundOptionParent = null;
  _.forEach(items, (category) => {
    if (!foundOptionParent && category?.options) {
      foundOptionParent = _.find(category.options, (option) => {
        if (option.subcategories) {
          const lastItemRecursiveKey = _.last(
            option.itemRecursiveKey.split(ITEM_KEY_CATEGORY_SEPARATOR)
          );
          return (
            option.subcategories.includes(lastOptionKey) &&
            optionKey.includes(lastItemRecursiveKey)
          );
        }
        return false;
      });
      foundOptionParent = foundOptionParent && {
        ...foundOptionParent,
        categoryMultiple: category.categoryMultiple,
      };
    }
  });

  return foundOptionParent;
};

type DeleteItemParams = {
  userConnected: boolean;
  isUserAnonymous: boolean;
  customerId: string;
  cartItemKey: string;
  cartItem: any;
};

export const deleteItem = async ({
  userConnected,
  isUserAnonymous,
  customerId,
  cartItemKey,
  cartItem,
}: DeleteItemParams) => {
  const { nb, name, price, position, sectionName, key } = cartItem;
  if (userConnected || isUserAnonymous) {
    const { isDeleted, message } = await deletePendingOrderBasketItem(customerId, cartItemKey);
    if (isDeleted && isStringNotNull(message)) {
      store.dispatch(showMessageModal(message));
    }
  }
  sendGoogleAnalytics('remove_from_cart', {
    items: [
      {
        id: key,
        name,
        price,
        position,
        category: sectionName,
        quantity: nb,
      },
    ],
  });
  analyticsEvents.logRemoveFromCart(
    key,
    name,
    price,
    sectionName,
    nb,
    position
  );
};
